var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSgd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_2031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0001C0 8.95438 8.95437 0 20 0C31.0456 0 40 8.95438 40 20.0001",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1742 10.4345C12.1742 7.52062 14.2221 5.08641 16.9568 4.48914C16.5364 4.39742 16.1004 4.34766 15.6524 4.34766C12.2906 4.34766 9.56543 7.07281 9.56543 10.4346C9.56543 13.7964 12.2906 16.5216 15.6524 16.5216C16.1003 16.5216 16.5364 16.4718 16.9568 16.38C14.2221 15.7827 12.1742 13.3485 12.1742 10.4345Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 4.78247L20.4319 6.11099H21.8289L20.6987 6.93216L21.1304 8.26067L20.0002 7.43966L18.8701 8.26067L19.3018 6.93216L18.1716 6.11099H19.5685L20.0002 4.78247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.612 7.39062L17.0436 8.71922H18.4405L17.3104 9.54031L17.7421 10.8688L16.612 10.0478L15.4816 10.8688L15.9134 9.54031L14.7832 8.71922H16.1802L16.612 7.39062Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3891 7.39062L23.8209 8.71922H25.2178L24.0876 9.54031L24.5194 10.8688L23.3891 10.0478L22.259 10.8688L22.6907 9.54031L21.5605 8.71922H22.9574L23.3891 7.39062Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0845 11.3037L22.5162 12.6323H23.913L22.7829 13.4534L23.2146 14.7819L22.0845 13.9609L20.9543 14.7819L21.386 13.4534L20.2559 12.6323H21.6527L22.0845 11.3037Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9156 11.3037L18.3472 12.6323H19.7443L18.614 13.4534L19.0458 14.7819L17.9156 13.9609L16.7854 14.7819L17.2171 13.4534L16.0869 12.6323H17.4839L17.9156 11.3037Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_2031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgd);
export default __webpack_public_path__ + "static/media/SGD.c0f5eceaeba03c32385615e1f2fbab33.svg";
export { ForwardRef as ReactComponent };